<template>
    <div>
        <hr>
        <heading-icon :title="$t('PATIENTS')" icon="user"/>
        <div class="row my-3" id="filter-patients">
            <div class="col-8 d-flex m-auto">
                <div class="form-group">
                    <label for="flter-patients-input" class="col-lg-3">{{ $t('FILTER_PATIENTS') }}</label>
                    <input v-model="searchKey" type="text" id="flter-patients-input" class="form-control col-lg-7" >
                    <button @click="onSearchButtonClick" class="btn">{{ $t('FILTER_PATIENTS_BTN') }}</button>
                </div>
                <hr>
            </div>
            <div class="col-4 float-right text-right">
                <button @click="navigateToCreatePatient" class="btn"><icon icon="plus-circle" /> {{ $t('ADD_NEW_PATIENT') }}</button>
            </div>
        </div>

        <div class="card shadow mb-4">
            <b-alert
                :show="dismissCountDown"
                dismissible
                fade
                :variant="alertType"
                @dismissed="dismissCountDown = 0"
                >
                {{alertMessage}}
            </b-alert>
            <div class="card-body">
                <div class="table-responsive mb-3">
                    <b-table show-empty
                             :hover="true"
                             :items="patients"
                             :fields="fields"
                             :bordered="true">
                        <template v-slot:cell(firstName)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(lastName)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(sis)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(birthdate)="row">
                            {{ row.value.replace('T', ' ').slice(0,10) }}
                        </template>
                        <template v-slot:cell(language)="row">
                            {{ row.value ? row.value.longTitle : '' }}
                        </template>
                        <template v-slot:cell(email)="row">
                            {{ row.value }}
                        </template>
                        <template v-slot:cell(startCga)="row">
                            <button @click="startCga(row.item)" class="darker-danger-background btn btn-danger"><icon icon="play" /></button>
                        </template>
                        <template v-slot:cell(modify)="row">
                            <router-link :to="'patients/' + row.item.id + '/edit'">{{$t('MODIFY')}}</router-link>
                        </template>
                        <template v-slot:cell(delete)="row">
                            <a href="" @click="enableDeleteModal(row.item, $event)">{{$t('DELETE')}}</a>
                        </template>
                    </b-table>
                </div>
                <b-pagination-nav 
                    v-if="totalPages > 0"
                    v-model="currentPage" 
                    :link-gen="linkGeneration" 
                    :number-of-pages="totalPages"
                    :first-text="this.$t('PAGING_FIRST_PAGE')"
                    :last-text="this.$t('PAGING_LAST_PAGE')" 
                    use-router 
                    align="center">
                </b-pagination-nav>
            </div>
        </div>
    </div>
</template>
<script>
import Modal from './../../misc/Modal.vue';
import HeadingIcon from './../../misc/HeadingIcon.vue';
import pagingMixin from './../../../mixins/pagingMixin';

export default {
    mixins: [ pagingMixin ],
    components: {
        modal: Modal,
        HeadingIcon
    },
    data() {
        return {
            patients: [],
            currentPage: null,
            totalPatients: 0,
            totalPages: 1,
            searchKey: '',
            shouldLoadPatientsWithoutFilter: true,
            alertType: null,
            dismissCountDown: 0,
            alertMessage: '',

            deleteResponse: {},
            modalBody: null,
            modalTitle: "Delete Confirmation",
            modalButtonText: "Delete",
            showModal: false,
            modalPatientId: null
        }
    },
    computed: {
        fields () {
            return [
                { key: 'firstName', label: this.$t('FIRST_NAME'), sortable: true },
                { key: 'lastName', label: this.$t('LAST_NAME'), sortable: true },
                { key: 'sis', label: this.$t('SIS'), sortable: true },
                { key: 'birthdate', label: this.$t('BIRTHDATE'), sortable: true },
                { key: 'language', label: this.$t('LANGUAGE'), sortable: true },
                { key: 'email', label: this.$t('EMAIL'), sortable: true },
                { key: 'startCga', label: this.$t('CGA'), tdClass: 'fit' },
                { key: 'modify', label: this.$t('MODIFY'), tdClass: 'fit'  },
                { key: 'delete', label: this.$t('DELETE'), tdClass: 'fit'  }
            ]
        }
    },
    methods: {
        startCga: function (patient) {
            this.$store.dispatch("activateCga", patient).then(() => {
                this.$router.push({ name: 'cga' });
            })
        },
        deletePatient: function (patientId) {
            this.$http
                .delete(`/api/patients/${patientId}/delete/`)
                .then(response => {
                    var tempDeleteResponse = response.data;
                    tempDeleteResponse.id = patientId;
                    this.deleteResponse = tempDeleteResponse;
                }).catch(error => {
                    console.log(error);
                })
        },
        loadPatients: function () {
            this.$http
                .get(`/api/patients/get-all-on-page?p=${ this.currentPage }&q=${ this.searchKey }`)
                .then(response => {
                    //if (self.patients.length == 0) {
                    // this.loadTotalPatientsCount();
                    //}
                    this.patients = response.data;
                }).catch(error => {
                    console.log(error);
                });
            this.loadTotalPatientsCount();
        },
        loadTotalPatientsCount: function () {
            this.$http
                .get('/api/patients/count?q=' + this.searchKey)
                .then(response => {
                    this.totalPatients = response.data;
                    this.totalPages = this.calculateNumberOfPages(this.totalPatients);
                }).catch(error => {
                    console.log(error);
                })
        },
        linkGeneration: function (pageNumber) {
            return {
                path: '/',
                query: { p: pageNumber, q: this.searchKey }
            }
        },
        enableDeleteModal: function (patient, event) {
            event.preventDefault();
            let result = confirm("Are you sure you want to delete the Patient " + patient.firstName + ' ' + patient.lastName);
            if (result === true) {
                this.deletePatient(patient.id);
            }
        },
        // searchPatients: function () {
        //     if (this.currentPage != 1) {
        //         this.currentPage = 1;
        //     }
        //     if (this.searchKey && this.searchKey !== '') {
        //         this.$http
        //             .get(`/api/patients/search/${ this.searchKey }?p=${ this.currentPage }`)
        //             .then(response => {
        //                 this.patients = response.data;
        //             }).catch(error => {
        //                 console.log(error);
        //             });
        //         this.loadSearchedPatientsCount();
        //     } else {
        //         this.loadPatients();
        //     }

        //     this.$router.push({ 
        //         path: this.$route.path,
        //         query: { 
        //             p: this.currentPage,
        //             q: this.searchKey 
        //         }
        //     });    
        // },
    //     loadSearchedPatientsCount: function () {
    //         this.$http
    //             .get(`/api/patients/search/${this.searchKey}/count`)
    //             .then(response => {
    //                 this.totalPatients = response.data;
    //                 this.totalPages = this.calculateNumberOfPages(this.totalPatients);
    //             }).catch(error => {
    //                 console.log(error);
    //             })
    //     }
    // },
        findPatients: function () {
            this.$router.push({ 
                path: this.$route.path,
                query: { 
                    p: this.currentPage,
                    q: this.searchKey 
                }
            });
        },
        onSearchButtonClick: function () {
            this.currentPage = 1;
            this.findPatients();
            this.loadPatients();
        },
        navigateToCreatePatient() {
            this.$router.push({ path: '/patients/add' });
        }
    },
    created: function () {
        this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;

        if (this.$route.query.q) {
            this.searchKey = this.$route.query.q;
        }
    },
    watch: {
        deleteResponse: function (val) {
            if (val.success === true) {
                // get index of object with id: val.id
                var removeIndex = this.patients.map(function(item) { return item.id; }).indexOf(val.id);
                // remove object
                this.patients.splice(removeIndex, 1);

                this.alertMessage = "Patient Successfully Deleted";
                this.alertType = "success";  
            } else {
                this.alertMessage = "Unsuccessful attempt at deleting a doctor";
                this.alertType = "danger";
            }

            this.dismissCountDown = 3;
            
        },
        currentPage: function (val) {
            this.loadPatients();
        }
    }
}
</script>
<style lang="scss" scoped>
a.btn.btn-primary.col-3{
    border-color: #fff;
    border-width: 2px;
}

input.btn.btn-primary.col-4{
    border-color: #fff;
    border-width: 2px;
    
    
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: gainsboro;
    opacity: 1; /* Firefox */
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: gainsboro;
}
::-ms-input-placeholder { /* Microsoft Edge */
    color: gainsboro;
}

.center {
  margin: auto;
  width: 50%;
  border: 2px solid white;
  padding: 10px;
}
#add-patient-btn {
    height: 80%
}

#filter-patients {
    div:first-child {
        display: flex;
        label {
            justify-content: center;
            padding-top: 1.5%;
        }
    }
}
.b-table .my-left-border {
  border-left: 3px solid #000;
}
</style>